export default "/images/ad32f81c9b267c904c1fe97e3c5f8287.avif";